import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./headers.css";
import logo from "../../Assets/logo.png";
import { FaBars } from "react-icons/fa";
import MobileMenu from "./MobileMenu/MobileMenu";

const Headers = () => {
    const [apiDropdownOpen, setApiDropdownOpen] = useState(false);
    const [sitesDropdownOpen, setSitesDropdownOpen] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            if (window.innerWidth > 768) {
                setMobileMenuOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const toggleApiDropdown = () => {
        setApiDropdownOpen(!apiDropdownOpen);
        setSitesDropdownOpen(false);
    };

    const toggleSitesDropdown = () => {
        setSitesDropdownOpen(!sitesDropdownOpen);
        setApiDropdownOpen(false);
    };

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
        // Prevent scrolling when menu is open
        document.body.style.overflow = mobileMenuOpen ? 'auto' : 'hidden';
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
        document.body.style.overflow = 'auto';
    };

    return (
        <>
            <header className="header">
                <div className="header-container">
                    {/* Logo on the left */}
                    <div className="header-left">
                        <Link to="/" className="logo-with-text">
                            <div className="logo-container">
                                <img src={logo} alt="Logo" className="logo-icon" />
                                <div className="logo-text-container">
                                    <div className="logo-text-datagreffe">DATAGREFFE</div>
                                    <div className="logo-text-justice">justice</div>
                                </div>
                            </div>
                        </Link>

                        <a href="mailto:contact@datagreffe.ci" className="header-contact">
                            contact@datagreffe.ci
                        </a>
                    </div>

                    {/* Desktop navigation */}
                    <nav className="header-nav">
                        {/* Dropdown API */}
                        {/* <div className="header-dropdown">
                            <button className="header-link" onClick={toggleApiDropdown}>
                                API
                                <span className="dropdown-icon">▼</span>
                            </button>
                            {apiDropdownOpen && (
                                <div className="dropdown-content pappers-dropdown">
                                    <div className="pappers-item">
                                        <Link to="/api-docs" className="pappers-link">
                                            <div className="pappers-title">API</div>
                                            <div className="pappers-sous-title">Documentation</div>
                                            <div className="pappers-description">Référence technique et guides</div>
                                        </Link>
                                        <span className="external-link-icon">↗</span>
                                    </div>
                                    <div className="pappers-item">
                                        <Link to="/developer" className="pappers-link">
                                            <div className="pappers-title">API</div>
                                            <div className="pappers-sous-title">Developer</div>
                                            <div className="pappers-description">Portail développeur et clés d'API</div>
                                        </Link>
                                        <span className="external-link-icon">↗</span>
                                    </div>
                                    <div className="pappers-item">
                                        <Link to="/api-tarifs" className="pappers-link">
                                            <div className="pappers-title">API</div>
                                            <div className="pappers-sous-title">Tarifs</div>
                                            <div className="pappers-description">Forfaits et options de tarification</div>
                                        </Link>
                                        <span className="external-link-icon">↗</span>
                                    </div>
                                </div>
                            )}
                        </div> */}

                        {/* Dropdown Nos Sites Web */}
                        <div className="header-dropdown">
                            <button
                                className="header-link"
                                onClick={toggleSitesDropdown}
                            >
                                Nos sites
                                <span className="dropdown-icon">▼</span>
                            </button>
                            {sitesDropdownOpen && (
                                <div className="dropdown-content pappers-dropdown">
                                    <div className="pappers-item">
                                        <Link to="/entreprises" className="pappers-link">
                                            <div className="pappers-title">Datagreffe</div>
                                            <div className="pappers-sous-title">Entreprises</div>
                                        </Link>
                                        <span className="external-link-icon">↗</span>
                                    </div>
                                    <div className="pappers-item">
                                        <Link to="/politique" className="pappers-link">
                                            <div className="pappers-title">Datagreffe</div>
                                            <div className="pappers-sous-title">Justice</div>
                                        </Link>
                                        <span className="external-link-icon">↗</span>
                                    </div>
                                </div>
                            )}
                        </div>
                        <Link to="https://datagreffe.ci/dashboard" className="connexion-button">Connexion</Link>
                    </nav>

                    {/* Mobile menu hamburger icon */}
                    <button className="menu-toggle" onClick={toggleMobileMenu}>
                        <FaBars />
                    </button>
                </div>
            </header>

            {/* Mobile Menu Component */}
            <MobileMenu isOpen={mobileMenuOpen} onClose={closeMobileMenu} />
        </>
    );
};

export default Headers;